import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

/**
 * Draggable song item component for playlist editing
 */
function SortableItem({
  id,
  song,
  onRemove,
  loading,
  onEdit,
  editingPosition,
  tempPosition,
  setTempPosition,
  onSavePosition,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className='hover:bg-gray-50 grid grid-cols-12 items-center border-b p-3 last:border-b-0'
    >
      <div className='text-gray-500 col-span-1 flex items-center'>
        <span className='mr-2 cursor-move' {...attributes} {...listeners}>
          ⋮⋮
        </span>
        {editingPosition === song.id ? (
          <input
            type='number'
            min='1'
            className='w-12 rounded border p-1 text-center'
            value={tempPosition}
            onChange={(e) => setTempPosition(e.target.value)}
            autoFocus
          />
        ) : (
          <span>{song.position}</span>
        )}
        <button
          type='button'
          onClick={() => {
            if (editingPosition === song.id) {
              onSavePosition(song)
            } else {
              onEdit(song.id, song.position)
            }
          }}
          className='text-blue-500 hover:text-blue-700 ml-1'
          title={editingPosition === song.id ? 'Save position' : "Edit just this track's position"}
          disabled={loading}
        >
          {editingPosition === song.id ? '✓' : '✎'}
        </button>
      </div>
      <div className='col-span-5 font-medium'>{song.title}</div>
      <div className='text-gray-600 col-span-4'>{song.artists.join(', ')}</div>
      <div className='col-span-2 flex justify-end'>
        <button
          onClick={() => onRemove(song.id)}
          className='bg-red-500 hover:bg-red-600 text-white rounded px-2 py-1'
          disabled={loading}
          type='button'
        >
          Remove
        </button>
      </div>
    </div>
  )
}

export default SortableItem
